import { Features } from 'mk2/apps/strollers/schemas';
import { niceNumber } from 'mk2/apps/strollers/utils';
import * as React from 'react';
import styles from './MinMaxDimensionsFeature.mscss';

interface OwnProps {
    features: Features;
    feature: any;
}

const hasVal = (value) => {
    return (value !== undefined) && (value !== null);
};

const renderRange = (minValue, maxValue) => {
    if (hasVal(minValue) && hasVal(maxValue) && minValue !== maxValue) {
        return `${niceNumber(minValue)}–${niceNumber(maxValue)}`;   // beware: ndash used
    }
    const value = maxValue || minValue;
    return hasVal(value) ? niceNumber(value) : '?';
};

export class MinMaxDimensionsFeature extends React.Component<OwnProps> {
    public render() {
        const { feature, features } = this.props;

        if (!feature.hasWorthyValue(features)) {
            return null;
        }

        const dims = feature.getDims(features);

        return (
            <div className={styles.MinMaxDimensionsFeature}>
                {renderRange(dims.heightMin, dims.heightMax)}
                &nbsp;×&nbsp;
                {renderRange(dims.widthMin, dims.widthMax)}
                &nbsp;×&nbsp;
                {renderRange(dims.lengthMin, dims.lengthMax)}
            </div>
        );
    }
}
